import axios from 'axios'

const getApiClient = (store = null) => {
    let api = axios.create({
        baseURL: process.env.VUE_APP_API_URL,
        withCredentials: true
    });

    api.interceptors.request.use(function (config) {
        store.commit('startLoading')
        let token = store.state.session.token
        if (token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    });


    api.interceptors.response.use( (response) => {
        store.commit('stopLoading')
        return response;
    }, (error) => {
        store.commit('stopLoading')
        if (error.response.status !== 401) {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        if (error.config.url === 'auth') {
            return new Promise((resolve, reject) => {
                reject(error);
            });
        }

        // Try request again with new token
        return store.dispatch('refreshToken')
            .then((response) => {
                const config = error.config,
                    token = store.state.session.token

                config.headers['Authorization'] = `Bearer ${token}`

                return new Promise((resolve, reject) => {
                    axios.request(config).then(response => {
                        resolve(response)
                    }).catch((error) => {
                        reject(error)
                    })
                });

            })
            .catch((error) => {
                Promise.reject(error)
            });
    });

    return api
}

export default getApiClient
